<section class="fixed-scroll country_blocked">
  <div class="site_modal middleAlignBlock" [ngStyle]="{'background-image': 'url('+ countryBlockBg +')'}">
    <div class="middleAlign">
      <div class="site_modal--body site_modal--body-small">
        <div class="contry_top_section">
          <h3 class="text-center">{{'countryblockComp.countryblock1' | translate}}</h3>
          <p>{{'countryblockComp.countryblock2' | translate}}</p>
        </div>
        <div class="blocked_panel">
          <div class="panel-body">
            <div class="pull-left countryblock-leftbody">
              <div class="pull-left countryblock-leftbody--icon">
                <img src="{{siteUrlPath}}/{{mediaUrlPath}}/country_restrict_icon.png" />
              </div>
              <div class="pull-right country_box">
                <h4>{{'countryblockComp.countryblock3' | translate}}</h4>
                <p>{{'countryblockComp.countryblock4' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="blocked_panel">
          <div class="panel-body">
            <div class="pull-left countryblock-leftbody">
              <div class="pull-left countryblock-leftbody--icon contact-img">
                <img src="{{siteUrlPath}}/{{mediaUrlPath}}/country_contact_icon.png" />
              </div>
              <div class="pull-right country_box">
                <h4>{{'countryblockComp.countryblock5' | translate}}</h4>
                <p>{{'countryblockComp.countryblock6' | translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
